import { useEffect, useState } from "react"
import FormComp from "../../../Componentes/FormComp"
import Overlay from "../../../Componentes/Overlay"
import Formulario from "../../../Componentes/Utils/Formulario"
import Modal from "../../../Componentes/Utils/Modal"
import useApi from "../../../hooks/useApi";

const ModalAddChecklistModel = ({ id_tipo, fetchSuccess, itemEdit, fecharModelo }) => {
    const api = useApi();


    const [ isEditing, setIsEditing ] = useState( false );

    useEffect(() => {
        if( !itemEdit ){
            return;
        }

        setIsEditing( true );
        setNomeModelo( itemEdit.nome || '' );
        setHasEquipamento( itemEdit.equipamento ? '1' : '0' );
    }, [itemEdit])

    const [ nomeModelo, setNomeModelo ] = useState('');
    const [ hasEquipamento, setHasEquipamento ] = useState( '0' );

    const [ loading, setLoading ] = useState( false );

    const handleSubmit = async ( e ) => {

        e.preventDefault();

        setLoading( true );

        try{

            const formData = new FormData();

            formData.append('modelo', nomeModelo);
            formData.append('id_tipo', id_tipo);
            formData.append('equipamento', hasEquipamento);

            let url;

            if( isEditing ){
                url = "/Painel/API/Checklist/EditModelo/";
                formData.append('id', itemEdit.id);
            }else{
                url = "/Painel/API/Checklist/SaveNewModelo/"
            }

            await api.post(url, formData);
            
            if( fetchSuccess ){
                await fetchSuccess();
            }
            fecharModelo();

        }catch( e ){

            console.error( e );

        }finally{

            setLoading( false );

        }

    }

    return(
        <>
            <Overlay state={ true } >
                <Modal header close={ fecharModelo } >
                    <Formulario onSubmit={( e ) => handleSubmit( e ) }>
                        <FormComp
                            title="NOME DO MODELO"
                            type="text"
                            valor={ nomeModelo }
                            changeFunc={( e ) => setNomeModelo( e.target.value.toUpperCase())}
                        />
                        <FormComp
                            title="EQUIPAMENTO"
                            type="select"
                            options={[
                                { label: 'SIM' , value: '1' },
                                { label: 'NÃO' , value: '0' }
                            ]}
                            obj={ true }
                            valor={ hasEquipamento }
                            changeFunc={( e ) => setHasEquipamento( e.target.value ) }
                        />
                        <FormComp
                            type="submit"
                            valor={ loading ? "SALVANDO..." : "SALVAR" }
                        />
                    </Formulario>
                </Modal>
            </Overlay>
        </>
    )
}

export default ModalAddChecklistModel;